export default __webpack_public_path__ + "static/media/phoneko.e33484f2.png";